import { FC } from 'react'
import { VStack } from '@chakra-ui/react'
import {
  IPadding,
  ISectionTestMatchWordsWithImages,
  ITestContentMatchWordsWithImages
} from 'shared/types'
import get from 'lodash/get'
import PaddingSelect from 'components/PaddingSelect'
import HighlightCorrectAnswer from 'components/contentSettingsCard/HighlightCorrectAnswer'
import SimpleInput from 'shared/components/SimpleInput'
import { getTestTitle } from 'shared/utils/tests'
import EditTestMatchWithImages from 'components/sections/editSectionTestMatchWithImages/EditTestMatchWithImages'

type Props = {
  s: ISectionTestMatchWordsWithImages
  onChange: (s: ISectionTestMatchWordsWithImages) => void
}

const EditSectionTestMatchWithImages: FC<Props> = ({ s, onChange }) => {
  const renderPadding = () => {
    return (
      <PaddingSelect
        value={s.paddingTop}
        onChange={(v: IPadding) => onChange({ ...s, paddingTop: v })}
      />
    )
  }

  const renderHighlightCorrectAnswer = () => {
    const v = get(s, 'test.highlightCorrectAnswer', false)
    return (
      <HighlightCorrectAnswer
        value={v}
        onChange={(v: boolean) =>
          onChange({
            ...s,
            test: { ...(s.test || {}), highlightCorrectAnswer: v }
          })
        }
      />
    )
  }

  const renderTitle = () => {
    return (
      <SimpleInput
        value={s.test?.title || getTestTitle(s.type)}
        onChange={(v: string) =>
          onChange({ ...s, test: { ...(s.test || {}), title: v } })
        }
        label='Вопрос'
      />
    )
  }

  const renderEditContent = () => {
    return (
      <EditTestMatchWithImages
        test={s.test || {}}
        onChange={(v: ITestContentMatchWordsWithImages) =>
          onChange({ ...s, test: v })
        }
      />
    )
  }

  return (
    <VStack w='full' spacing={6}>
      {renderPadding()}
      {renderTitle()}
      {renderHighlightCorrectAnswer()}
      {renderEditContent()}
    </VStack>
  )
}

export default EditSectionTestMatchWithImages
